import { z } from 'zod';

export const affordabilityCalculatorPostRequestSchema = z.object({
  annual_income: z.string(),
  deposit: z.string(),
  monthly_spend: z.string().optional(),
  net_monthly_income: z.string().optional(),
});
